import { createComparator } from '@tmapy/utils';
const RE_VERSION = new RegExp(/^(\d+)\.(\d+)\.(\d+)(?:-([^$]*))?$/);
const parseVersion = (version) => {
    const match = RE_VERSION.exec(version);
    if (!match) {
        return null;
    }
    return {
        major: parseInt(match[1] ?? '', 10),
        minor: parseInt(match[2] ?? '', 10),
        patch: parseInt(match[3] ?? '', 10),
        release: match[4],
    };
};
const versionComparer = createComparator((version) => version?.major ?? 0, (version) => version?.minor ?? 0, (version) => (version ? version.patch + 1 : 0), (version) => version?.release ?? '');
export const compareVersions = (firstVersion, secondVersion) => {
    const first = parseVersion(firstVersion);
    const second = parseVersion(secondVersion);
    return versionComparer(first, second);
};
//# sourceMappingURL=compareVersions.js.map